import { render, staticRenderFns } from "./KindTreatment.vue?vue&type=template&id=2ae83410&"
import script from "./KindTreatment.vue?vue&type=script&lang=js&"
export * from "./KindTreatment.vue?vue&type=script&lang=js&"
import style0 from "./KindTreatment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports